export enum FilterControlTypes {
  TextInput = "TextInput",
  NumberInput = "NumberInput",
  DecimalInput = "DecimalInput",
  Calender = "Calender",
  CalenderWithTime = "CalenderWithTime",
  DropDown = "DropDown",
  AutoComplete = "AutoComplete",
  CheckBox = "CheckBox",
  BinaryDropDown = "BinaryDropDown"
}
